import React from "react";
import "./Styles/Loading.css";
export default function Loading(){

    return (
        <div className="cargando">
            <div className="loader"></div>
        </div>
        
    );
}